import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavegadorCheckService {

  constructor() { }

  NavegadorSuportado(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const vendor = window.navigator.vendor?.toLowerCase() || '';

    const isOpera = /opr\//.test(userAgent) || /opera\//.test(userAgent);
    if (isOpera) return false;

    const isBrave = !!(window.navigator as any).brave;
    if (isBrave) return false;

    const isVivaldi = /vivaldi\//.test(userAgent);
    if (isVivaldi) return false;

    const isEdge = /edg\//.test(userAgent);
    if (isEdge) return true;

    const isChrome = /chrome/.test(userAgent) && /google inc/.test(vendor) && !/edg/.test(userAgent);
    if (isChrome) return true;

    const isSafari = /safari/.test(userAgent) && /apple computer/.test(vendor) && !/chrome/.test(userAgent);
    if (isSafari) return true;

    return false;
  }
}
